import { observer } from 'mobx-react';
import { Component } from 'react';
import OrderCurbsideInput from '../OrderCurbsideInput/OrderCurbsideInput';
import { CheckoutStore } from 'src/mobx/checkoutStore';

interface IProps {
  className?: string;
  checkoutStore: CheckoutStore;
}

@observer
export default class OrderCurbside extends Component<IProps, {}> {
  get checkoutStore() {
    return this.props.checkoutStore;
  }
  render() {
    return (
      <div className={`d-flex flex-column ${this.props.className || ''}`}>
        {/* car brand */}
        <OrderCurbsideInput
          inputKey="car_brand"
          label="car_brand"
          value={this.checkoutStore.dependencies.curbside.car_brand}
          error={this.checkoutStore.validatorErrors.car_brand}
        />
        {/* car color */}
        <OrderCurbsideInput
          inputKey="car_color"
          label="car_color"
          value={this.checkoutStore.dependencies.curbside.car_color}
          error={this.checkoutStore.validatorErrors.car_color}
        />
        {/* car number  */}
        <OrderCurbsideInput
          inputKey="car_number"
          label="car_number"
          value={this.checkoutStore.dependencies.curbside.car_number}
          error={this.checkoutStore.validatorErrors.car_number}
        />
        {/* car type */}
        <OrderCurbsideInput
          inputKey="car_type"
          label="car_type"
          value={this.checkoutStore.dependencies.curbside.car_type}
          error={this.checkoutStore.validatorErrors.car_type}
        />
      </div>
    );
  }
}
